import { render, staticRenderFns } from "./ExamEdit.vue?vue&type=template&id=0c49441a"
import script from "../../controllers/exam/exam-edit.js?vue&type=script&lang=js&external"
export * from "../../controllers/exam/exam-edit.js?vue&type=script&lang=js&external"
import style0 from "./ExamEdit.vue?vue&type=style&index=0&id=0c49441a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports